import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
export type KarteUserProfileUserFragment = { __typename?: 'User', id: string, nickname: string, channel: Types.Channel, livingPrefecture?: Types.Prefecture | null, birthYear?: number | null, gender: Types.UserGender, numberOfMatch: number, address?: { __typename?: 'UserAddress', prefecture: string, city: string } | null };

export const KarteUserProfileUserFragmentDoc = gql`
    fragment KarteUserProfileUser on User {
  id
  nickname
  channel
  livingPrefecture
  birthYear
  gender
  address {
    prefecture
    city
  }
  numberOfMatch
}
    `;